<template>
  <div class="c-app">
    <ManagerSidebar />
    <CWrapper>
      <TheHeader :lastRouteName="lastRouteName" />
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path" @go-to="goTo"></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader";
import ManagerSidebar from "./ManagerSidebar";

export default {
  name: "Manager",
  components: {
    ManagerSidebar,
    TheHeader,
  },
  data() {
    return {
      lastRouteName: null,
    };
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.name !== "دروس") {
          this.lastRouteName = null;
        }
      },
    },
  },
  methods: {
    goTo(text) {
      this.lastRouteName = text;
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
